import { render, staticRenderFns } from "./add-to-cart-panel.vue?vue&type=template&id=79d915af&"
import script from "./add-to-cart-panel.vue.ts?vue&type=script&lang=ts&"
export * from "./add-to-cart-panel.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports